// extracted by mini-css-extract-plugin
export default {"companyNameBox":"CompanyName_companyNameBox__t8szE","companyName":"CompanyName_companyName__Nah+4","companyNameVisible":"CompanyName_companyNameVisible__Qz1lS"};